// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glossary-toggle-button {
    position: relative;
    width: 50px;
    height: 50px;
    color: var(--white-base);
    border-radius: 50%;
    cursor: pointer;
    /* border: rgba(0, 0, 0, 0.2) 1px solid; */
    font-size: 24px;
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    text-align: center;

    
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

/* .glossary-toggle-button:hover { */
    /* transform: scale(1.01); */
    /* Scale up the button on hover */
    /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.9); */
    /* Increase shadow on hover for a lifted effect */
    /* transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease; */
    /* Smooth transition for a polished feel */
/* } */

.glossary-toggle-icon{
    border-radius: 50%;
    background-color: #eee;
    width: 50px;
    height: 50px;
}

.glossary-toggle-close-button {
    position: relative;
    width: 35px;
    height: 35px;
    top: 0px;
    right: 0px;
    color: var(--white-base);
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    font-size: 24px;
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    text-align: center;
}

.glossary-toggle-close-button:hover {
    transform: scale(1.01);
    /* Scale up the button on hover */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
    /* Increase shadow on hover for a lifted effect */
    transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    /* Smooth transition for a polished feel */
}

.glossary-modal {
    z-index: 1000;
    position: fixed;
    top: 0;
    right: 0;
    border-radius: 20px 0px 0px 20px;
    width: 12.5%;
    height: 96%;
    background-color: var(--white-base);
    border-left: 1px solid var(--gray-20);
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
}

.glossary-header {
    display: flex;
    flex-direction: row;
    align-items: top;
    justify-content: space-between;
}

.glossary-title {
    font-family: Poppins;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
}

.glossary-close {
    width: 30px;
    height: 30px;
    color: var(--white-base);
    font-weight: bold;
    align-self: flex-end;
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: center;
    font-size: 24px;
    margin-bottom: 10%;
    margin-top:10%;
}

.glossary-search {
    margin-bottom: 20px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 20px;
}



.glossary-entries {
    overflow-y: auto;
    height: 100%;
}

.glossary-entry {
    padding: 10px;
    border-bottom: 1px solid #eee; /* Separate entries visually */
}

.glossary-name { 
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
}

.glossary-description {
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}`, "",{"version":3,"sources":["webpack://./src/widgets/GlossaryWidget.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,0CAA0C;IAC1C,eAAe;IACf,aAAa;IACb,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,kBAAkB;;;IAGlB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,oCAAoC;IAChC,4BAA4B;IAC5B,iCAAiC;IACjC,8CAA8C;IAC9C,iDAAiD;IACjD,uFAAuF;IACvF,0CAA0C;AAC9C,MAAM;;AAEN;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,eAAe;IACf,aAAa;IACb,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;IACjC,wCAAwC;IACxC,iDAAiD;IACjD,iFAAiF;IACjF,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,QAAQ;IACR,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,mCAAmC;IACnC,qCAAqC;IACrC,yCAAyC;IACzC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;;;AAIA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,6BAA6B,EAAE,8BAA8B;AACjE;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".glossary-toggle-button {\r\n    position: relative;\r\n    width: 50px;\r\n    height: 50px;\r\n    color: var(--white-base);\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    /* border: rgba(0, 0, 0, 0.2) 1px solid; */\r\n    font-size: 24px;\r\n    display: flex;\r\n    justify-content: center; /* Center horizontally */\r\n    align-items: center; /* Center vertically */\r\n    text-align: center;\r\n\r\n    \r\n    font-family: Poppins;\r\n    font-size: 30px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 150%;\r\n}\r\n\r\n/* .glossary-toggle-button:hover { */\r\n    /* transform: scale(1.01); */\r\n    /* Scale up the button on hover */\r\n    /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.9); */\r\n    /* Increase shadow on hover for a lifted effect */\r\n    /* transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease; */\r\n    /* Smooth transition for a polished feel */\r\n/* } */\r\n\r\n.glossary-toggle-icon{\r\n    border-radius: 50%;\r\n    background-color: #eee;\r\n    width: 50px;\r\n    height: 50px;\r\n}\r\n\r\n.glossary-toggle-close-button {\r\n    position: relative;\r\n    width: 35px;\r\n    height: 35px;\r\n    top: 0px;\r\n    right: 0px;\r\n    color: var(--white-base);\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n    font-size: 24px;\r\n    display: flex;\r\n    justify-content: center; /* Center horizontally */\r\n    align-items: center; /* Center vertically */\r\n    text-align: center;\r\n}\r\n\r\n.glossary-toggle-close-button:hover {\r\n    transform: scale(1.01);\r\n    /* Scale up the button on hover */\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);\r\n    /* Increase shadow on hover for a lifted effect */\r\n    transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;\r\n    /* Smooth transition for a polished feel */\r\n}\r\n\r\n.glossary-modal {\r\n    z-index: 1000;\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    border-radius: 20px 0px 0px 20px;\r\n    width: 12.5%;\r\n    height: 96%;\r\n    background-color: var(--white-base);\r\n    border-left: 1px solid var(--gray-20);\r\n    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n}\r\n\r\n.glossary-header {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: top;\r\n    justify-content: space-between;\r\n}\r\n\r\n.glossary-title {\r\n    font-family: Poppins;\r\n    font-size: 30px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n}\r\n\r\n.glossary-close {\r\n    width: 30px;\r\n    height: 30px;\r\n    color: var(--white-base);\r\n    font-weight: bold;\r\n    align-self: flex-end;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: center;\r\n    font-size: 24px;\r\n    margin-bottom: 10%;\r\n    margin-top:10%;\r\n}\r\n\r\n.glossary-search {\r\n    margin-bottom: 20px;\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 20px;\r\n}\r\n\r\n\r\n\r\n.glossary-entries {\r\n    overflow-y: auto;\r\n    height: 100%;\r\n}\r\n\r\n.glossary-entry {\r\n    padding: 10px;\r\n    border-bottom: 1px solid #eee; /* Separate entries visually */\r\n}\r\n\r\n.glossary-name { \r\n    font-family: Poppins;\r\n    font-size: 18px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 150%;\r\n}\r\n\r\n.glossary-description {\r\n    font-family: Poppins;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 150%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
